import React from 'react';

import { CardActionArea } from '@mui/material';

import { PureLink } from '@components/navigation';

import { URL_STYLES } from '../../LinkRendererView.constants';

import type { LinkContentProperties } from './LinkContent.types';

export const LinkContent: React.FC<LinkContentProperties> = ({
  url = '',
  isDisabled,
  dataTest = 'link_content',
  children,
}) => (
  <PureLink
    dataTest={dataTest}
    to={url}
    target='_blank'
    rel='noreferrer'
    style={URL_STYLES}
  >
    <CardActionArea disabled={isDisabled}>{children}</CardActionArea>
  </PureLink>
);
